import { render, staticRenderFns } from "./CustomDefinedField.vue?vue&type=template&id=037f94d1&scoped=true"
import script from "./CustomDefinedField.vue?vue&type=script&lang=ts"
export * from "./CustomDefinedField.vue?vue&type=script&lang=ts"
import style0 from "./CustomDefinedField.vue?vue&type=style&index=0&id=037f94d1&prod&scoped=true&lang=css"
import style1 from "./CustomDefinedField.vue?vue&type=style&index=1&id=037f94d1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037f94d1",
  null
  
)

export default component.exports